import Vue from 'vue';
import VueRouter from 'vue-router';
import createRoutes from '@/helpers/createRoutes';

Vue.use(VueRouter);

export const slides = [
  {
    path: '/',
    name: 'Intro',
    component: () => import(/* webpackChunkName: "slides" */ '@/pages/Intro.vue'),
    meta: {
      menu: 'В начало',
    },
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "slides" */ '@/pages/About.vue'),
    meta: {
      nextButtonText: 'Начать',
    },
  },
  {
    path: '/covid',
    name: 'COVID',
    component: () => import(/* webpackChunkName: "slides" */ '@/pages/Covid.vue'),
    meta: {},
  },
  {
    path: '/transformation',
    name: 'Transformation',
    component: () => import(/* webpackChunkName: "slides" */ '@/pages/Transformation.vue'),
    meta: {
      menu: 'Трансформация трудовой культуры',
    },
  },
  {
    path: '/evp',
    name: 'EVP',
    component: () => import(/* webpackChunkName: "slides" */ '@/pages/Evp.vue'),
    meta: {
      menu: 'Ценностное предложение работодателя',
    },
  },
  {
    path: '/valuation',
    name: 'Valuation',
    component: () => import(/* webpackChunkName: "slides" */ '@/pages/Valuation.vue'),
    meta: {
      menu: 'Как коронакризис скорректировал условия труда',
    },
  },
  {
    path: '/questions',
    name: 'Questions',
    component: () => import(/* webpackChunkName: "slides" */ '@/pages/Questions.vue'),
    meta: {
      menu: 'Опыт решения проблем от ведущих российских компаний',
    },
  },
  {
    path: '/reviews',
    name: 'Reviews',
    component: () => import(/* webpackChunkName: "slides" */ '@/pages/Reviews.vue'),
    meta: {},
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: () => import(/* webpackChunkName: "slides" */ '@/pages/Feedback.vue'),
    meta: {
      next: null,
      menu: 'Бонусы',
    },
  },
  {
    path: '/apps',
    name: 'Apps',
    component: () => import(/* webpackChunkName: "slides" */ '@/pages/Apps.vue'),
    meta: {
      prev: '/feedback',
      next: null,
    },
  },
  {
    path: '/evaluation',
    name: 'Evaluation',
    component: () => import(/* webpackChunkName: "slides" */ '@/pages/Evaluation.vue'),
    meta: {
      prev: '/feedback',
      next: null,
    },
  },
];

const router = new VueRouter({
  linkActiveClass: '_active',
  linkExactActiveClass: '_active_exact',
  routes: createRoutes(slides),
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
